import React from 'react';
import PropTpyes from 'prop-types';
import { IntlProvider } from 'react-intl';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import { ErrorBoundary, Notifications, Loader } from 'src/core/components';
import { routes as routeConstants, config } from 'src/constants';
import { getLoggedUserData } from 'src/utils';
import messages from 'src/i18n';
import { OligoDNAPage, EditSequencePage, EditPlatePage } from 'src/pages';
import 'src/assets/sass/global.scss';

import { AppRedirect } from './components';

import './App.scss';

const AppComponent = ({
  accessDetails,
}) => {
  const routes = [
    {
      path: routeConstants.OLIGODNA_PAGE,
      component: OligoDNAPage,
    },
    {
      path: routeConstants.EDIT_PLATE_PAGE,
      component: EditPlatePage,
    },
    {
      path: routeConstants.EDIT_SEQUENCE_PAGE,
      component: EditSequencePage,
    },
  ];

  const user = getLoggedUserData();

  return (
    <IntlProvider
      key={user.locale}
      locale={user.locale}
      defaultLocale="en"
      messages={messages[user.locale]}
    >
      <ErrorBoundary>
        <Router basename={config.baseRoute}>
          <Switch>
            {routes.map((route) => (
              <Route
                key={route.path}
                path={route.path}
                exact
                component={
                  accessDetails?.shouldRedirect ?
                    () => <AppRedirect url={accessDetails.url} /> :
                    route.component
                }
              />
            ))}
          </Switch>
        </Router>
        <Notifications />
        <Loader />
      </ErrorBoundary>
    </IntlProvider>
  );
};

AppComponent.propTypes = {
  accessDetails: PropTpyes.object,
};

export default AppComponent;
